<template>
  <div class="va-row dealDetails" id="dealDetails">    
    <div class="va-row">
      <div class="flex xs12 md12">
        <vuestic-widget style="margin-bottom: 0;">
          <div class="table-responsive">
            <table class="table table-striped first-td-padding">
              <thead>
              <tr>
                <td v-cloak>{{ tableData['0']['2'] }}</td>
                <td v-cloak>{{ tableData['0']['16'] }}</td>
                <td v-cloak>{{ tableData['0']['20'] }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in tableData.slice(1)">
                <td v-if="item && itemHK(item, '2')" v-cloak>{{ item['2'] ? item['2'] : ''}}</td>
                <td v-if="item && itemHK(item, '3')" style="padding-left: 40px !important;" v-cloak>&nbsp;&nbsp;{{ item['3'] ? item['3'] : '' }}</td>
                <td v-cloak>{{ item['16'] ? item['16'] : '' }}</td>
                <td v-cloak>{{ item['20'] ? item['20'] : ''}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'settlementDetails',
  props: {
    tableData: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {}
  },
  methods: {
    itemHK(obj, no) {
      let bol = typeof obj[no] !== 'undefined' ? true : false
      return bol
    }
  }
}
</script>

<style lang='scss' scoped>
[v-cloak] {
  display: none;
}
#backParent {
  position: absolute;
  top: 146px;
  right: 80px;
}
</style>